import React, { useState } from 'react';
import './otpsignup.scss';

const ForgotPassword = ({ onBack }) => {
    
    const handleRedirectAfterSubmit = (e) => {
        window.location.replace('/users/sign_in');
    };

    return (
        <>
            <div className="text-left mb-6">
                <h1 className="text-sm font-medium text-white">Reset</h1>
                <h1 className="text-3xl font-medium text-white">Forgot Password?</h1>
            </div>
            <form
                action="/users/password"
                method="POST"
                onSubmit={handleRedirectAfterSubmit}
            >
                <input
                    type="hidden"
                    name="authenticity_token"
                    value={document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')}
                />
                
                <div className="flex-col">
                    <div className="text-left">
                        <label htmlFor="forgot-email" className="inline-block text-sm text-white mb-2">
                            Email
                        </label>
                        <input
                            id="forgot-email"
                            type="email"
                            name="user[email]"
                            autoComplete="email"
                            className="block appearance-none w-full bg-white border border-gray-400 text-gray-700 py-3 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            placeholder="Enter your email address"
                            required
                        />
                    </div>
                </div>
                
                <button
                    type="submit"
                    className="w-full cursor-pointer text-sm px-4 py-3 bg-white text-purple-500 rounded-lg hover:bg-purple-500 hover:text-white mt-4 mr-3 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Send instructions
                </button>
            </form>
            
            <p
                className="cursor-pointer text-sm text-white mt-5 hover:underline transition-all"
                onClick={onBack}
            >
                <i className="fas fa-arrow-left mr-2"></i>Back to login
            </p>
        </>
    );
};

export default ForgotPassword;